import {Component, Vue} from "vue-property-decorator";
import WithRender from "./App.html";
import { hasAuthToken, isLogoutPath, redirectToSsoLogin } from '@/Services/ssoNavigation';
@WithRender
@Component({})
export default class App extends Vue {
    public themeCompany: any = "Default";

    public async created() {
        const currentPath = window.location.pathname;
        const allowedPaths = ["/AddProviderRequest", "/public-route"];
        if (!hasAuthToken()) {
            if (allowedPaths.includes(currentPath) || isLogoutPath(currentPath)) {
                this.setupThemeAndLanguage();
                return;
            } else {
                await redirectToSsoLogin();
                return;
            }
        }
        this.setupThemeAndLanguage();
    }


    private setupThemeAndLanguage() {
        if (process.env.VUE_APP_TITLE !== undefined) {
            this.themeCompany = process.env.VUE_APP_TITLE.toString();
        } else {
            this.themeCompany = "Default";
        }

        if (localStorage.dir === undefined) {
            localStorage.dir = "ltr";
            this.$i18n.locale = "en";
        } else if (localStorage.dir === "rtl") {
            this.$i18n.locale = "ar";
        } else {
            this.$i18n.locale = "en";
        }
    }

    public get dir() {
        return localStorage.dir;
    }
}
